export const userPreferencesManagementKeys = {
    all: ['userPreferencesManagement'] as const,
    user: () => [...userPreferencesManagementKeys.all, 'user'] as const,
    preference: (key: string) => [...userPreferencesManagementKeys.all, 'preference', key] as const,
    currentUser: () => [...userPreferencesManagementKeys.all, 'currentUser'] as const,
}
